// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import NoDataCell from '../NoDataCell';
import { formatMessage } from '@/utils/i18n/i18n';
import { ImpliedTemperatureLimit, ESGColourDefinition } from '@/enums/Esg';
import ComparisonItem from '@/types/comparison-item';
import DisclaimerInfos from '@/types/disclaimer-infos';
import Locale from '@/types/locale';

type Props = {
  value?: number;
  className?: string;
  item?: ComparisonItem;
  disclaimer?: string;
  onClick?: () => void;
  id?: string;
  valueDisclaimer?: DisclaimerInfos;
  hasDisclaimer?: boolean;
  locale?: Locale;
};

const TemperatureCell: React.FunctionComponent<Props> = ({
  value,
  className,
  disclaimer,
  valueDisclaimer,
  item,
  onClick,
  id,
  hasDisclaimer,
  locale,
}: Props) => {
  if (value == null) {
    return <NoDataCell disclaimerKey={disclaimer} item={item} onClick={onClick} id={id} locale={locale} />;
  }

  const fixedValue: number = +value.toFixed(1);
  let tempIntensityColor;
  let tempIntensityLabel;

  switch (true) {
    case fixedValue <= ImpliedTemperatureLimit.ALIGNED_LOW:
      tempIntensityColor = ESGColourDefinition.TEXT_STRONGLY_ALIGNED;
      tempIntensityLabel = formatMessage('ESGComparisonTool.ImpliedTemperatureRise.TemperatureRanking.ALIGNED');
      break;
    case fixedValue <= ImpliedTemperatureLimit.ALIGNED:
      tempIntensityColor = ESGColourDefinition.TEXT_ALIGNED;
      tempIntensityLabel = formatMessage('ESGComparisonTool.ImpliedTemperatureRise.TemperatureRanking.ALIGNED');
      break;
    case fixedValue <= ImpliedTemperatureLimit.MISALIGNED:
      tempIntensityColor = ESGColourDefinition.TEXT_MODERATE;
      tempIntensityLabel = formatMessage('ESGComparisonTool.ImpliedTemperatureRise.TemperatureRanking.MISALIGNED');
      break;
    default:
      tempIntensityColor = ESGColourDefinition.TEXT_STRONGLY_MISALIGNED;
      tempIntensityLabel = formatMessage('ESGComparisonTool.ImpliedTemperatureRise.TemperatureRanking.STRONGLY_MISALIGNED');
      break;
  }

  return (
    <div className={classNames(className, 'cell esg-rating-cell')} id={id ? `cell-${id}` : undefined} style={{ color: tempIntensityColor }} onClick={onClick}>
      <span className="markup-container">
        {fixedValue} °C ({tempIntensityLabel})
      </span>
    </div>
  );
};

export default TemperatureCell;
